import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-085a791c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "evolution-type-container"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  class: "symbol"
};
const _hoisted_4 = {
  key: 0
};
const _hoisted_5 = {
  key: 1
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_switch_horizontal_icon = _resolveComponent("switch-horizontal-icon");
  const _component_wrap_with_popover = _resolveComponent("wrap-with-popover");
  const _component_chevron_selector_vertical_icon = _resolveComponent("chevron-selector-vertical-icon");
  const _component_chevron_up_icon = _resolveComponent("chevron-up-icon");
  const _component_chevron_down_icon = _resolveComponent("chevron-down-icon");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_wrap_with_popover, {
    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
    style: {
      width: 'fit-content'
    }
  }, {
    title: _withCtx(() => [_createElementVNode("div", {
      innerHTML: $props.typeButtonDescription.title
    }, null, 8, _hoisted_2)]),
    content: _withCtx(() => [_createTextVNode(_toDisplayString($props.typeButtonDescription.detail), 1)]),
    default: _withCtx(() => [_createElementVNode("div", {
      class: "evolution-type-button",
      onClick: _cache[0] || (_cache[0] = $event => _ctx.$emit('click', $event))
    }, [_createElementVNode("div", _hoisted_3, [$props.evolutionType === 'percentage' ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.currencyConfig?.symbol), 1)) : _createCommentVNode("", true), $props.evolutionType === 'currency' ? (_openBlock(), _createElementBlock("div", _hoisted_5, " % ")) : _createCommentVNode("", true)]), _createVNode(_component_switch_horizontal_icon)])]),
    _: 1
  }), $props.showSortButton ? (_openBlock(), _createBlock(_component_wrap_with_popover, {
    key: 0,
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
    width: 'fit-content'
  }, {
    title: _withCtx(() => [_createTextVNode(_toDisplayString($options.dynamicSortButtonDescription.detail), 1)]),
    default: _withCtx(() => [$props.baseColumnSorted || ['asc', 'desc'].includes($props.sortState) ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: "sort-direction-button",
      onClick: _cache[2] || (_cache[2] = (...args) => $options.toggleSortDirection && $options.toggleSortDirection(...args))
    }, [$props.baseColumnSorted && !['asc', 'desc'].includes($props.sortState) ? (_openBlock(), _createBlock(_component_chevron_selector_vertical_icon, {
      key: 0,
      width: "12",
      height: "12"
    })) : $props.sortState === 'asc' ? (_openBlock(), _createBlock(_component_chevron_up_icon, {
      key: 1,
      width: "12",
      height: "12"
    })) : $props.sortState === 'desc' ? (_openBlock(), _createBlock(_component_chevron_down_icon, {
      key: 2,
      width: "12",
      height: "12"
    })) : _createCommentVNode("", true)])) : _createCommentVNode("", true)]),
    _: 1
  })) : _createCommentVNode("", true)]);
}